module.exports = __webpack_public_path__ + "static/media/cell.bd29fb78.md";